
import { mapGetters, mapMutations } from 'vuex'
import Loading from 'vux/src/components/loading/index.vue'
import Toast from 'vux/src/components/toast/index.vue'

import MiniPlayer from '@/components/miniPlayer.vue'

export default {
data() {
return {
loadText: '加载中',
}
},
computed: {
...mapGetters(['isLoad', 'isMiniPlayer', 'isToast']),
},
methods: {
...mapMutations(['setToast']),
totast() {
this.setToast(false)
},
},
components: {
MiniPlayer,
Loading,
Toast,
},
}
